import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Card, 
  Text, 
  Button, 
  FlexBox, 
  FlexBoxDirection, 
  FlexBoxJustifyContent, 
  FlexBoxAlignItems,
  Icon,
  Title
} from '@ui5/webcomponents-react';

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      backgroundColor: '#f5f5f5'
    }}>
      <Card
        style={{
          width: '450px',
          padding: '2rem',
          textAlign: 'center',
          boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
        }}
      >
        <FlexBox
          direction={FlexBoxDirection.Column}
          justifyContent={FlexBoxJustifyContent.Center}
          alignItems={FlexBoxAlignItems.Center}
        >
          <Icon 
            name="locked" 
            style={{ 
              fontSize: '3rem', 
              color: '#FF5722',
              marginBottom: '1rem' 
            }} 
          />
          
          <Title level="H2" style={{ color: '#D32F2F', marginBottom: '1rem' }}>
            Acceso Denegado
          </Title>
          
          <Text style={{ marginBottom: '2rem', fontSize: '1rem' }}>
            No tienes los permisos necesarios para acceder a esta página.
            Por favor, contacta con el administrador si crees que deberías tener acceso.
          </Text>

          <Button 
            onClick={() => navigate('/home')}
            style={{ marginTop: '1rem' }}
          >
            Volver al Inicio
          </Button>
        </FlexBox>
      </Card>
    </div>
  );
};

export default AccessDenied; 